module.exports = __webpack_public_path__ + "static/media/pngInactive.c9a910a6.svg";